<template>
  <div class="user-wrp-comments">
    <div class="result-bracket__title user__list-count">
      <span class="result-bracket__count">{{ ques.length }} </span> Soru Bulundu !
    </div>
    <div class="user__list-offer">
      <QuestionsAnswer :question="question"  v-for="question in ques" :key="question.id" />
    </div>
  </div>
</template>

<script>
import QuestionsAnswer from '@/components/QuestionAnswer'
export default {
  name: 'Offers',
  components: {
    QuestionsAnswer
  },
  props: {
    ques: Array
  }
}
</script>

<style lang="scss">
  @import "../assets/scss/components/comments";
</style>
